import { useEffect, useRef } from 'react';

const MARCA = '__overlay';

// Los editores que ocupan la pantalla entera se leen como páginas: el gesto de
// atrás de Android tiene que cerrarlos, no salir de la app. Como no son rutas,
// al abrirlos empujamos una entrada de historial propia (misma URL) y
// escuchamos el popstate para cerrarlos.
export default function useBackToClose(open, onClose) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;

    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const previo = window.history.state || {};
    // Se conserva (y avanza) el idx de React Router: es como lleva la cuenta de
    // saltos, y si lo perdemos navigate(-1) empieza a moverse de más o de menos.
    window.history.pushState({ ...previo, idx: (previo.idx ?? 0) + 1, [MARCA]: id }, '');

    let cerradoPorAtras = false;
    const alVolver = () => {
      cerradoPorAtras = true;
      onCloseRef.current?.();
    };
    window.addEventListener('popstate', alVolver);

    return () => {
      window.removeEventListener('popstate', alVolver);
      // Sólo consumimos nuestra entrada si seguimos parados en ella. Si el
      // overlay se cerró porque navegamos a otra ruta (por ejemplo el botón de
      // equipos), volver atrás desharía esa navegación.
      if (!cerradoPorAtras && window.history.state?.[MARCA] === id) {
        window.history.back();
      }
    };
  }, [open]);
}
